import React, { useEffect, useState } from "react";
import { fetchSheets, createSheet } from "../api.js";
import SheetRow from "../components/SheetRow.jsx";
import ContactsGrid from "../components/ContactsGrid.jsx";

export default function AddNamesRamadan() {
  const [sheets, setSheets] = useState([]);
  const [localNames, setLocalNames] = useState(Array(30).fill(""));
  const [localPhones, setLocalPhones] = useState(Array(30).fill(""));

  useEffect(() => {
    fetchSheets().then(setSheets);
  }, []);

  async function add() {
    const doc = await createSheet(localNames, localPhones);
    setSheets((prev) => [doc, ...prev]);
    setLocalNames(Array(30).fill(""));
    setLocalPhones(Array(30).fill(""));
  }

  function onChange(updated, deleted = false) {
    setSheets((prev) => {
      if (deleted) return prev.filter((d) => d._id !== updated._id);
      return prev.map((d) => (d._id === updated._id ? updated : d));
    });
  }

  return (
    <div>
      {sheets.length <= 0 ? (
        <>
          <h2>Add A List of Sponsors</h2>
          <ContactsGrid
            initialNames={localNames}
            initialPhones={localPhones}
            onSave={(names, phones) => {
              setLocalNames(names);
              setLocalPhones(phones);
            }}
            onClear={(clearedNames, clearedPhones) => {
              setLocalNames(clearedNames);
              setLocalPhones(clearedPhones);
            }}
          />
          <button onClick={add}>Create Sheet</button>
        </>
      ) : (
        <h2>List of Ramadan Sponsors</h2>
      )}
      {/* <h3>Existing Sheets</h3> */}
      {sheets.map((sheet) => (
        <SheetRow key={sheet._id} sheet={sheet} onChange={onChange} />
      ))}
      <div>
        <h1
          style={{
            textAlign: "center",
            marginTop: "-10px",
          }}
        >
          Middletown Islamic Center (NEW YORK)
        </h1>
        <h2
          style={{
            textAlign: "center",
            marginTop: "-20px",
            marginBottom: "1px",
          }}
        >
          Ramadan 2026 | 1447
        </h2>
        <table className="custom-table">
          <thead>
            <tr>
              <th>Column 1</th>
              <th>Column 2</th>
              <th>Column 3</th>
              <th>Column 4</th>
            </tr>
          </thead>
          <tbody>
            {/* {rows.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))} */}
            <tr>
              <td>
                <b>Ramadan # 1 | February 17 | Tuesday</b> <br />
                <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {/* {docs && docs[0]?.names[0]} */}
                  {sheets && sheets[0]?.names[0]} | &nbsp;
                  {sheets && sheets[0]?.phones[0]}
                </span>
              </td>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
            </tr>
            <tr>
              <td>
                <b>Ramadan # 2 | February 18 | Wednesday</b> <br />
                <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {/* {docs && docs[0]?.names[1]} */}
                </span>
              </td>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
            </tr>
            <tr>
              <td>
                <b>Ramadan # 3 | February 19 | Thursday</b> <br />
                <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {/* {docs && docs[0]?.names[2]} */}
                </span>
              </td>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
            </tr>
            <tr>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
            </tr>
            <tr>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
            </tr>
            <tr>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
            </tr>
            <tr>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
            </tr>
            <tr>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
              <td>Sample 1</td>
            </tr>
          </tbody>
        </table>

        {/* CSS styles in the same page */}
        <style>
          {`
          .custom-table {
            width: 100%;
            border-collapse: collapse;
            // margin-top: 20px;
            font-family: Arial, sans-serif;
          }
          .custom-table th, .custom-table td {
            border: 1px solid #333;
            padding: 10px;
            text-align: center;
          }
          .custom-table th {
            background-color: #4CAF50;
            color: white;
          }
          .custom-table tr:nth-child(even) {
            background-color: #f2f2f2;
          }
          .custom-table tr:hover {
            background-color: #ddd;
          }
        `}
        </style>
      </div>
    </div>
  );
}
